// import { useEffect, useState } from "react"

import dayjs from 'dayjs';

import { Page, Text, View, Document } from '@react-pdf/renderer';


import { styles } from './styles/styles';
import { Header3 } from './common/header';
// import { FooterStyle1 } from "./common/footer"
// import { BodyTopStyle1 } from './common/bodyTop';
import { BodyMainHeaderStyle4 } from './common/bodyMainHeader';
import { productInjectionFields } from '../../../hooks/model/useProduct';
import { itemInjectionFields } from '../../../hooks/model/useProductItem';
// import { BodyMainHeaderStyle4 } from './common/bodyMainFooter'
// import { BodyMainRowStyle3 } from './common/bodyMainRow';

// import {
// _invoiceItemCodes,
// customInjectionProps as salesInvoiceInjectionProps
// } from "../../../schema/documents/generateFromDOSchema"

// config
const _documentLabel = "SALES INVOICE";

const RenderBodyMain = (props) => {

    const { data } = props

    let qty = data?.items.reduce((total, item) => {
        total += parseInt(item[itemInjectionFields.packQty.retrieveKey], 10)
        return total
    }, 0)

    let courierTrackingNo = data[productInjectionFields.courierTrackingNo.retrieveKey]
    courierTrackingNo = courierTrackingNo.trim()

    let courierTrackingNoArray = []
    let _courierTrackingNo = ``

    // check the spaces between 
    if (courierTrackingNo.includes(" ") === true) {

        courierTrackingNoArray = courierTrackingNo.split(" ")

        if (courierTrackingNoArray.length > 0) {
            _courierTrackingNo = `${courierTrackingNoArray[0]}(${courierTrackingNoArray.length})`
        }

    } else if (courierTrackingNo !== "-") {

        _courierTrackingNo = `${courierTrackingNo}`

    }

    return (
        <View
            style={{
                fontWeight: 800
            }}
        >
            <BodyMainHeaderStyle4
                {...props}
                data1={{
                    companyPoNo: `${data[productInjectionFields.companyPurchaseNumber.retrieveKey]}`,
                    supplierPoNo: `${data[productInjectionFields.supplierPurchaseNumber.retrieveKey]}`,
                    barcodeDataUrl: data?.barcodeDataUrl,
                    barcodeText: `${data[productInjectionFields.barcode.retrieveKey]}`
                }}
            />
            <BodyMainHeaderStyle4
                {...props}
                isEnd
                data2={{
                    receivedBy: `${data[productInjectionFields.signedByUserDisplay.retrieveKey]}`,
                    qty,
                    remark: `${data[productInjectionFields.remark.retrieveKey]}`,
                    courierText: `${_courierTrackingNo}`
                }}
            />
            {/* <View>
                {
                    data.map((i, index) => {

                        // getting injection props
                        let totalCbm = i[salesInvoiceInjectionProps.totalCbm.retrieveKey]
                        let totalWeight = i[salesInvoiceInjectionProps.totalWeight.retrieveKey]
                        let totalQty = i[salesInvoiceInjectionProps.totalQty.retrieveKey]

                        totalCbm = parseFloat(totalCbm).toFixed(4)
                        totalWeight = parseFloat(totalWeight).toFixed(4)
                        totalQty = parseFloat(totalQty).toFixed(2)

                        let description = i?.description

                        if (i?.code.toLowerCase() === _invoiceItemCodes.transport.code.toLowerCase()) {
                            description += `\n(CBM: ${totalCbm} / Weight: ${totalWeight})`
                        }

            if (i?.code.toLowerCase() === _invoiceItemCodes.parcel.code.toLowerCase()) {
                description += `\n(Total Packages: ${totalQty})`
            }

            i.description = description

            return <BodyMainRowStyle3 key={index} row={i} index={index} />
                    })
                }
        </View> */}
            {/* {
                (pageNumber === totalPages) &&
                <BodyMainHeaderStyle4 document={document} data={data} summary={summary} />
            } */}
        </View >
    )
}

const RenderHeader = (props) => {

    const { data } = props;

    // return (
    //     <Header
    //         {...props}
    //         document={{
    //             header,
    //             documentName: _documentLabel,
    //             documentNumber: document?.doc_number
    //         }}
    //     />
    // )

    // console.log('data >>>', data)

    let checkInDate = dayjs(data[productInjectionFields.checkinDateTime.retrieveKey]).format("YYYY-MM-DD")

    return (
        <Header3
            {...props}
            document={{
                documentName: _documentLabel
            }}
            data={{
                locationAbb: `${data[productInjectionFields.registerLocationDisplay.retrieveKey]}`,
                marking: `${data[productInjectionFields.customerMarking.retrieveKey]}`,
                checkInDate
            }}
        />
    )
}

const RenderPage = (props) => {

    const { pageVariants, pageNumber, totalPages, data, document, header, summary } = props

    // console.log('props', props)

    return (
        // <Page size="A4" style={styles.page} wrap>
        <Page
            // size="A4" 
            style={[styles.page, {
                paddingTop: 5,
                paddingBottom: 5,
                paddingLeft: 10,
                paddingRight: 10,
            }]}
            orientation='portrait'
            wrap
            size={{
                // width: 189.00, // 2.5inch 
                width: 297.64, // 10cm 
                // height: 267.87, // 9cm = 9 * 297.64 / 10
                height: 223.23, // 7.5cm = 9 * 297.64 / 10
                // height: totalPx
                // 595.28 // 170 + 20 + 50xn
            }}
        >
            {/* <View render={(props) => <RenderHeader {...props} document={document} header={header} />} fixed /> */}
            <RenderHeader pageVariants={pageVariants} totalPages={totalPages} pageNumber={pageNumber} data={data} />
            {/* <BodyTopStyle1 pageNumber={pageNumber} totalPages={totalPages} qrCodeData={qrCodeData} document={document} /> */}
            <RenderBodyMain pageNumber={pageNumber} totalPages={totalPages} document={document} data={data} summary={summary} />
            {/* <FooterStyle1 document={document} /> */}
        </Page>
    )
}

export function Output({ routeType, document, data, account }) {

    const { document: _document, items: _items, document_header: _documentHeader, qrCodeData } = data;

    console.log('data', data)

    // const rowPerPage = 1;

    // calculate total pages
    // const totalPages = Math.floor(_items.length / rowPerPage);

    // let array = [];

    // for (let i = 0; i <= totalPages; i += 1) {
    //     array.push(i)
    // }

    // calculate total summary
    const totalQty = _items.reduce((total, val) => total + parseFloat(val?.qty), 0)

    const summary = {
        totalQty
    }

    return (
        <Document
            title={document?.title}
        >
            {
                data.items.map((i, index) => {

                    // const startFrom = index === 0 ? 0 : index * rowPerPage
                    // const startTo = index === 0 ? rowPerPage : startFrom + rowPerPage

                    // // slide the needed array subset data
                    // const data = _items.slice(startFrom, startTo)

                    return (
                        <RenderPage
                            // routeType={routeType}
                            pageNumber={(index + 1)}
                            totalPages={data.length}
                            // qrCodeData={qrCodeData}
                            account={account}
                            document={_document}
                            header={_documentHeader}
                            // data={data}
                            data={i}
                            key={index}
                            summary={summary}
                        />
                    )
                })
            }
        </Document>
    )
}